export default "__VITE_ASSET__Bfenltcs__"